module.exports = __webpack_public_path__ + "img/1.54c871bb.jpg";